const SCALE = 5
const FIELD_SIZE = 250
// const SPHERE_RADIUS = 15
const HP_COLOR = 0xffffff

const settings = {
    scale: SCALE,
    FIELD_SIZE: FIELD_SIZE * SCALE,
    SPHERE_RADIUS: 15,
    HP_COLOR,
}

export default settings
